import {
  AppBar,
  Avatar,
  Toolbar,
  Typography,
  Button,
  IconButton,
} from '@material-ui/core';
import React,{useState, useEffect} from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import decode from "jwt-decode"
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import useStyles from './styles';
//import memories from '../../images/memories.jpg';
//import memories from '../../images/memories.png';
import memories from '../../images/memorie.png';

import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness4OutlinedIcon from '@material-ui/icons/Brightness4Outlined';
import Brightness2Icon from '@material-ui/icons/Brightness2';

// const memories =
//   'https://cdn.dribbble.com/users/725870/screenshots/7528654/media/fe537e494848f99fb3b59153a606815a.jpg?compress=1&resize=400x300&vertical=top';

const Navbar = ({ darkMode, onChange }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
  //console.log("User: ", user)
  const [darkModeState, setDarkModeState] = useState(darkMode);
  console.log('the onChange: ', onChange)
  console.log('the darkModeState: ', darkModeState);

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });

    history.push('/');

    setUser(null);
  };

  useEffect(() => {
    const token = user?.token;

    if (token) {
      const decodedToken = decode(token);

      if (decodedToken.exp * 1000 < new Date().getTime()) {
        handleLogout();
      }
    }

    setUser(JSON.parse(localStorage.getItem('profile')));
  }, [location]);

  const handleDarkMode = () => {
    setDarkModeState(!darkModeState);
    onChange(!darkModeState);
  }

  return (
    <AppBar className={classes.appBar} position='static' color='inherit'>
      <div className={classes.brandContainer}>
        <Typography
          component={Link}
          to='/'
          className={classes.heading}
          variant='h2'
          align='center'
        >
          ShareWFriends
        </Typography>
        <img className={classes.image} src={memories} alt='icon' height='60' />
      </div>
      <Toolbar className={classes.toolbar}>
        {user ? (
          <div className={classes.profile}>
            <Avatar
              className={classes.purple}
              alt={user.result.name}
              src={user.result.imageUrl}
            >
              {user.result.name.charAt(0)}
            </Avatar>
            <Typography className={classes.userName} variant='h6'>
              {user.result.name}
            </Typography>
            <IconButton
              variant='contained'
              className={classes.logout}
              color='secondary'
              onClick={handleLogout}
            >
              <ExitToAppIcon style={{ fontSize: '40px' }} />
              {/* <span>logout</span> */}
            </IconButton>
          </div>
        ) : (
          // <Button component={Link} to="/auth" variant="contained" color="primary">Sign In</Button>
          <IconButton
            component={Link}
            to='/auth'
            variant='contained'
            color='primary'
          >
            <AccountCircleIcon style={{ fontSize: '40px' }} />
            <span>login</span>
          </IconButton>
        )}
      </Toolbar>
      <Button>
        <Button
          color='link'
          onClick={() => {
            handleDarkMode();
          }}
        >
          {darkModeState ? <Brightness4Icon /> : <Brightness2Icon />}
          {/* <span className='d-lg-none d-md-block'>Switch mode</span> */}
        </Button>
      </Button>
    </AppBar>
  );
};

export default Navbar